export const colors = {
  "DARK ACCENT": "custom.accent",
  PRIMARY: "custom.primary",
  "ACCENT LINK": "custom.accentLink",
  GREEN: "custom.success",
  DEFAULT: "custom.text",
};
